import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import {
  LoginAlpa,
  New_ScrollX2025,
  Scrollx_animate,
  SliderArrowIcon,
  Star_particles,
} from "../../assets/icons";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { login } from "../../Redux/actions/authActions";
import {
  getUserAllInformation,
  hasUserFilledSurvey,
} from "../../Redux/actions/commonActtion";
import SignUpWithGoogle from "../GoogleSignUp/SignUpWithGoogle";
import SuccessModal from "../Dashboard/SuccessModal";
import { ToastContainer } from "react-toastify";

export default function NewLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMesg, setErrorMesg] = useState("");
  const [path, setPath] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signInLoading, setSignInLoading] = useState(false);
  const [move, setMove] = useState(false);

  const [form, setForm] = useState({
    data: {
      email: "",
      password: "",
    },
    errorMessage: {
      email: "",
      password: "",
    },
  });

  const submitHandler = async (e) => {
    e.preventDefault();
    setSignInLoading(true);
    setErrorMesg("");

    try {
      const res = await dispatch(login(email, password));

      if (res?.status === 200) {
        // ✅ Wait for user information to be fetched before showing success
        await dispatch(getUserAllInformation());

        const userFilledSurvey = await hasUserFilledSurvey();
        localStorage.setItem(
          "userFilledSurvey",
          JSON.stringify(userFilledSurvey)
        );

        setSuccessModal(true);
        setPath("/register");
        setErrorMesg("");
      } else if (
        res?.response?.status === 400 &&
        res?.response?.data?.error &&
        !res?.response?.data?.success
      ) {
        setErrorMesg("Incorrect username or password.");
        setSuccessModal(false);
      } else {
        // ✅ Ensure data is loaded before navigation
        await dispatch(getUserAllInformation());
        navigate("/dashboard");
      }
    } catch (error) {
      console.log("error", error);
      setErrorMesg("An unexpected error occurred. Please try again.");
    }

    setSignInLoading(false);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClick = () => {
    setMove(true); // Move to 0px

    setTimeout(() => {
      setMove(false); // Return to 100px after a short delay
    }, 3000); // Adjust the delay as needed (1000ms = 1 second)
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );
  return (
    <div className="w-full h-full">
      <ToastContainer closeButton={CloseButton} />
      <div className="main_div">
        {successModal && (
          <SuccessModal
            successModal={successModal}
            setSuccessModal={setSuccessModal}
            errorMesg={errorMesg}
            path={path}
          />
        )}

        {signInLoading && (
          <div className="modal-overlayLoader">
            <img
              className="absolute opacity-80"
              src={Scrollx_animate}
              width="120px"
              height="120px"
            />
            <p className="mt-[8rem] text-[0.9rem] text-white">Signing in...</p>
          </div>
        )}

        <div className="w-full h-full flex ScalingLoginPAge relative">
          {/* Left Block */}
          <div className="flex lg:hidden py-3 w-full  items-center justify-center bg-[#1e1f2a] absolute ">
            <img className="w-[35px]" src={New_ScrollX2025} alt="icon" />
            <span className="ml-[10px] text-white Syne text-xl font-light tracking-wide manrope-600">
              ScrollX.io
            </span>
          </div>
          <div className="lg:w-[45%] w-[100%] loginRight-block flex justify-center items-center bg-[#1e1f2a]">
            <div className="lg:w-[57%] w-[83%]  h-1/2 flex flex-col justify-center items-center relative">
              <img
                className="w-[350px] absolute left-[-40%] lg:top-[-5%] top-[-20%]"
                src={Star_particles}
                alt=""
              />

              <div className="w-[90%] flex flex-col justify-center items-start ">
                <h1 className="text-white lg:text-4xl  text-[33px]   manrope-600 ">
                  Sign in
                </h1>
                <h2 className="white-80 xl:text-[15px] manrop-400 pt-3 pb-4">
                  Welcome back! Not a member?{" "}
                  <Link to="/register">
                    <span className="text-white underline xl:text-[15px] manrope-600 ">
                      Create your account.
                    </span>{" "}
                  </Link>
                </h2>
              </div>
              <div className="w-[90%]  flex items-center  ">
                <SignUpWithGoogle />
              </div>
              <div className="w-[90%] flex justify-center items-center pt-[14px]">
                <div className="w-[45%] h-[1px] self-center bg-[#797979] "></div>
                <div className="w-[10%]   text-center manrope-400  xl:text-lg text-white">
                  or
                </div>
                <div className="w-[45%]  h-[1px] self-center bg-[#797979]"></div>
              </div>
              <form onSubmit={submitHandler} className="w-[90%]">
                <div className="mb-6 mt-6 flex">
                  <input
                    className="email-place NewLoginInput inputBorder w-full"
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    required
                  />
                </div>

                <div className="mb-[20px] flex items-center relative">
                  <input
                    className="NewLoginInput inputBorder"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                  />
                  <div
                    className="absolute right-4 cursor-pointer text-white"
                    onClick={handleShowPassword}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </div>
                </div>
                <div className="mb-[20px]">
                  {errorMesg && (
                    <p className="text-white manrope-400 text-sm ">
                      {errorMesg}
                    </p>
                  )}
                </div>
                <div className="flex flex-col  items-start ">
                  <div className=" w-full   overflow-hidden">
                    <button
                      type="submit"
                      className={`px-2 py-2 w-full flex justify-between bg-[#5e51d1] manrope-600  rounded-[10px] text-white xl:text-base`}
                      onClick={handleClick}
                      // disabled={
                      //   !form?.data?.email ||
                      //   !form?.data?.password
                      // }
                    >
                      <img
                        className="lg:w-[28px] w-[40px] mr-2 transition-transform duration-[1000ms] ease-in-out transform"
                        style={{ transform: `translateX(${move ? 650 : 0}px)` }}
                        src={SliderArrowIcon}
                        alt="icon"
                      />
                      <span className="manrope-600 py-[2.5px] w-full text-center ml-[-28px]">
                        Log in
                      </span>
                    </button>
                  </div>

                  <div className="py-[6px] mt-[14px]">
                    <span className="text-white manrope-400">
                      <Link className="text-sm" to="/forgotpassword">
                        Forgot your Password?
                      </Link>
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Right Block */}
          <div className="lg:w-[55%]  lg:flex hidden bg-[#0a0a0a] flex flex-col justify-center items-center ">
            <div className="w-[55%] h-[63%] text-white">
              <div className="pl-[15%]">
                <div className="flex pt-2 pb-3 items-center">
                  <img className="w-[35px]" src={New_ScrollX2025} alt="icon" />
                  <span className="ml-[10px] Syne text-xl font-light tracking-wide manrope-600">
                    ScrollX.io
                  </span>
                </div>
                <h1 className="pt-2 pb-4  text-[33px] manrope-400">
                  <span className="manrope-800">ScrollX.io</span>, the simplest
                  way <br />
                  to create your end credits
                </h1>
                <p className="text-base manrope-400 ">
                  Generate stunning, production-ready end credits that are
                  beautifully styled and perfectly structured—ready to use
                  <br />
                  within minutes.
                </p>
              </div>
              <div className="mt-[14px]">
                <img
                  className="scale-x-[-1]  object-cover  "
                  src={LoginAlpa}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
